module.exports = __webpack_public_path__ + "static/media/failed_icon.977dd676.svg";